import type React from "react";
import {forwardRef, memo} from "react";

import {headingStyle} from "./styles";
import type {IHeadingProps} from "./types";

const Heading = memo(
    forwardRef<React.ElementRef<"span">, IHeadingProps>(
        (
            {
                className,
                variant = "xl",
                color = "blueGray.800",
                textTransform,
                numberOfLines,
                testID,
                ...props
            },
            ref
        ) => {
            const {isTruncated, bold, underline, strikeThrough, sub, italic, highlight} = props;

            return (
                <span
                    className={headingStyle({
                        isTruncated,
                        bold,
                        underline,
                        strikeThrough,
                        variant,
                        sub,
                        italic,
                        highlight,
                        color,
                        textTransform,
                        numberOfLines,
                        class: className
                    })}
                    {...props}
                    ref={ref}
                    data-testid={testID}
                />
            );
        }
    )
);

Heading.displayName = "Heading";

export {Heading};
